/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorCounselingReportAnswerTypename = "PharmacyCounselorCounselingReportAnswer" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorCounselingReportAnswer
 */
export interface PharmacyCounselorCounselingReportAnswer {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorCounselingReportAnswer
   */
  freeEntry?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorCounselingReportAnswer
   */
  optionId?: number;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorCounselingReportAnswer
   */
  questionnaireId?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorCounselingReportAnswer
   */
  readonly __typename?: string;
}

export function PharmacyCounselorCounselingReportAnswerFromJSON(json: any): PharmacyCounselorCounselingReportAnswer {
  return PharmacyCounselorCounselingReportAnswerFromJSONTyped(json, false);
}

export function PharmacyCounselorCounselingReportAnswerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorCounselingReportAnswer {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorCounselingReportAnswerTypename,

    freeEntry: !exists(json, "free_entry") ? undefined : json["free_entry"],
    optionId: !exists(json, "option_id") ? undefined : json["option_id"],
    questionnaireId: !exists(json, "questionnaire_id") ? undefined : json["questionnaire_id"],
  };
}

export function PharmacyCounselorCounselingReportAnswerToJSON(
  object?: PharmacyCounselorCounselingReportAnswer | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    free_entry: value.freeEntry,
    option_id: value.optionId,
    questionnaire_id: value.questionnaireId,
  };
}
